import React, { useState, useEffect, useRef } from "react";
import "./index.css";

import {
  ChevronRightIcon,
  ChevronLeftIcon,
  CheckIcon,
  MapPinIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";

import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo-light.png";
import dashboardScreenshots from "../../assets/orion-screenshot.png";
import phoneImage from "../../assets/grafico-celular.png";
import { default as FaqSection } from "./sections/faq";

import useBlogPosts from "../../hooks/useBlogPosts";
import { PostContentText } from "../blog/components/PostContentText";
import { convertToBrazilDate } from "../../helpers/date";

import { Footer, ProfitRanking, OpenTradesRanking } from "../../components";
import { Navbar } from "./components";

import babson from "../../assets/babson.jpg";
import orionStore from "../../assets/orion-store.png";

const STORE_URL = "https://loja.orionsinais.com.br";

function LandingPage() {
  const featuresCarousel = useRef(null);
  const blogCarousel = useRef(null);
  const [, setWidth] = useState(window.innerWidth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { blogPosts, loadingBlogPosts } = useBlogPosts({
    featured: true,
    limit: 6,
  });

  const plans = [
    {
      id: 1,
      title: "Assinatura anual",
      price: "R$ 499",
    },
  ];

  useEffect(() => {
    let resizeTimer;
    const handleResizeWindow = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        requestAnimationFrame(() => {
          setWidth(window.innerWidth);
        });
      }, 100);
    };

    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
      clearTimeout(resizeTimer);
    };
  }, [setWidth]);

  const navigate = useNavigate();

  const navigateToSignUp = () => {
    navigate("/cadastro");
  };

  const handleCarouselLeftClick = (e, carouselRef) => {
    e.preventDefault();
    requestAnimationFrame(() => {
      if (carouselRef.current) {
        const scrollWidth = carouselRef.current.offsetWidth;
        carouselRef.current.scrollBy({
          left: -scrollWidth,
          behavior: "smooth",
        });
      }
    });
  };

  const handleCarouselRightClick = (e, carouselRef) => {
    e.preventDefault();
    requestAnimationFrame(() => {
      if (carouselRef.current) {
        const scrollWidth = carouselRef.current.offsetWidth;
        carouselRef.current.scrollBy({
          left: scrollWidth,
          behavior: "smooth",
        });
      }
    });
  };

  const isDragging = (e, carouselRef) => {
    e.preventDefault();
    carouselRef.current.scrollLeft -= e.movementX;
  };

  return (
    <div className="orion__landing-page">
      <Navbar page={"landing"} />
      <div className="orion__landing-content">
        <div className="orion__landing-hero">
          <div className="orion__hero-content">
            <div className="orion__hero-left">
              <div className="orion__hero-text-content">
                <div className="title-container">
                  <h1>
                    <span className="no-break">
                      Pare de perder tempo adivinhando
                    </span>
                    <br />o próximo movimento do mercado!
                  </h1>
                  <h2>
                    <i>
                      Receba <b className="gradient">sinais estratégicos</b> e
                      comece <b className="gradient">agora</b> mesmo!
                    </i>
                  </h2>
                </div>
              </div>
              <div className="orion__hero-screenshot">
                <div className="hero" onClick={() => setIsModalOpen(true)}>
                  <img
                    alt="Capturas de tela do dashboard"
                    src={dashboardScreenshots}
                  />
                </div>
              </div>
            </div>
            <div className="orion__hero-right">
              <ProfitRanking />
            </div>
          </div>
        </div>
        <div
          className="orion__landing-presentation"
          id="orion__landing-presentation"
        >
          <div className="orion__presentation-left-column">
            <h2 className="orion__landing-title">SOBRE A PLATAFORMA</h2>
            <h3>
              Auxiliamos você a tomar decisões com base em{" "}
              <b className="gradient">sinais estratégicos</b>
            </h3>
            <p>
              Nossas estratégias são desenvolvidas por uma equipe de
              especialistas com anos de experiência no mercado de criptoativos,
              utilizando uma combinação de métodos de análise técnica e
              fundamental para identificar as melhores oportunidades de
              investimento.
            </p>
            <p></p>
            <div className="orion__presentation-button">
              <a style={{ textDecoration: "none" }} href="#orion__plan-section">
                <button className="orion__default-button">
                  Conheça nossos Preços
                </button>
              </a>
              <a href="#orion__faq-section">Dúvidas? Confira nosso FAQ</a>
            </div>
          </div>
          <div className="orion__presentation-right-column">
            <img
              className="orion__phone-image"
              src={phoneImage}
              alt="grafico-celular"
            ></img>
          </div>
        </div>

        <div className="orion__gradient-section">
          <div className="orion__features-section" id="orion__features-section">
            <div className="orion__features-header">
              <div className="orion__features-header-text">
                <small>BENEFÍCIOS</small>
                <p>
                  Nossa plataforma é ideal para quem não tem tempo para
                  acompanhar constantemente o mercado cripto e não quer perder a
                  oportunidade de investir!
                </p>
              </div>
              <div className="orion__carousel-buttons-wrapper">
                <div
                  className="orion__carousel-button"
                  onClick={(e) => handleCarouselLeftClick(e, featuresCarousel)}
                >
                  <ChevronLeftIcon />
                </div>
                <div
                  className="orion__carousel-button"
                  onClick={(e) => handleCarouselRightClick(e, featuresCarousel)}
                >
                  <ChevronRightIcon />
                </div>
              </div>
            </div>
            <div
              className="orion__carousel-wrapper"
              ref={featuresCarousel}
              onDrag={(e) => isDragging(e, featuresCarousel)}
            >
              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>RECEBA VIA TELEGRAM</small>
                  <p>
                    Receba sinais diretamente em seu Telegram em um canal
                    exclusivo
                  </p>
                </div>
              </div>
              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>MAIORES LUCROS</small>
                  <p>
                    Aumente suas chances de sucesso no mercado de criptoativos
                  </p>
                </div>
              </div>
              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>ECONOMIA DE TEMPO</small>
                  <p>Ganhe tempo e evite erros de análise</p>
                </div>
              </div>

              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>MAIS DE 240 CRIPTOS</small>
                  <p>
                    Aprenda sobre o mercado de criptoativos com os melhores
                    especialistas
                  </p>
                </div>
              </div>
              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>REALIZE OPERAÇÕES</small>
                  <p>Faça operações na corretora de sua preferência</p>
                </div>
              </div>
              <div className="orion__carousel-card-container">
                <div className="orion__carousel-card">
                  <small>RECEBA VIA WHATSAPP</small>
                  <p>Em breve!</p>
                </div>
              </div>
            </div>
          </div>

          <div className="orion__signal-section">
            <div className="orion__signal-list-header">
              <div className="orion__signal-list-header-text">
                <h2>Sinais abertos mais lucrativos</h2>
                <p>
                  Acompanhe em tempo real os 5 sinais abertos com melhor
                  performance da nossa plataforma. Veja como nossos sinais estão
                  gerando lucros consistentes para nossos usuários!
                </p>
              </div>
            </div>
            <OpenTradesRanking />
          </div>
          <div className="orion__plan-section" id="orion__plan-section">
            <div className="orion__plan-new-layout">
              <div className="orion__plan-left-column">
                <div className="orion__plan-section-title">
                  <h2 className="orion__landing-title">PREÇOS</h2>
                  <h3>Pronto para receber sinais?</h3>
                  <p>
                    Oferecemos os melhores sinais de compra e venda de
                    criptoativos com assinatura anual de{" "}
                    <strong>R$ 499/ano</strong>.
                  </p>
                </div>
                <div className="orion__plan-benefits">
                  <small>TODOS AS ASSINATURAS OFERECEM:</small>
                  <div className="orion__plan-section-benefit">
                    <CheckIcon className="benefit-icon" />
                    <p>Simulador de ganhos</p>
                  </div>
                  <div className="orion__plan-section-benefit">
                    <CheckIcon className="benefit-icon" />
                    <p>Sinais via Telegram</p>
                  </div>
                  <div className="orion__plan-section-benefit">
                    <CheckIcon className="benefit-icon" />
                    <p>Compra 100% segura</p>
                  </div>
                  <div className="orion__plan-section-benefit">
                    <CheckIcon className="benefit-icon" />
                    <p>Pagamento via Pix</p>
                  </div>
                </div>
              </div>

              <div
                className={`orion__plan-cards-wrapper ${plans.length === 1 ? "single-plan" : ""}`}
              >
                {plans.map((plan) => (
                  <div key={plan.id} className="orion__plan-card best">
                    <div className="orion__plan-card-header">
                      <h1>{plan.price}</h1>
                      <p>{plan.title}</p>
                    </div>
                    <div className="orion__plan-card-button-wrapper">
                      <button
                        className="orion__default-button"
                        onClick={navigateToSignUp}
                      >
                        Assinar agora
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className="orion__features-section"
            id="orion__featured-posts-section"
          >
            <div className="orion__features-header">
              <div className="orion__features-header-text">
                <small>ARTIGOS EM DESTAQUE</small>
                <p>
                  Conheça nossos artigos mais recentes com dicas e análises
                  sobre o mercado de criptoativos
                </p>
              </div>
              {!loadingBlogPosts && (
                <div className="orion__carousel-buttons-wrapper">
                  <div
                    className="orion__carousel-button"
                    onClick={(e) => handleCarouselLeftClick(e, blogCarousel)}
                  >
                    <ChevronLeftIcon />
                  </div>
                  <div
                    className="orion__carousel-button"
                    onClick={(e) => handleCarouselRightClick(e, blogCarousel)}
                  >
                    <ChevronRightIcon />
                  </div>
                </div>
              )}
            </div>
            {loadingBlogPosts ? (
              <p>Carregando posts em destaque...</p>
            ) : (
              <div
                className="orion__carousel-wrapper"
                ref={blogCarousel}
                onDrag={(e) => isDragging(e, blogCarousel)}
              >
                {blogPosts.length > 0 ? (
                  blogPosts.map((post) => (
                    <div
                      className="orion__carousel-card-container"
                      key={post.id}
                    >
                      <div className="orion__carousel-card">
                        <div className="orion__blog-post-title-container">
                          <h1 className="orion__blog-post-title">
                            {post.title}
                          </h1>
                        </div>
                        <small className="orion__blog-post-date">
                          {convertToBrazilDate(post.published_at)}
                        </small>
                        <div className="orion__blog-post-description">
                          <PostContentText
                            content={post.content}
                            className="orion__blog-post-content-text"
                          />
                        </div>
                        <a
                          href={`/blog/post/${post.id}`}
                          className="orion__blog-post-link"
                        >
                          Ler mais
                        </a>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="orion__carousel-card-container">
                    <div className="orion__carousel-card">
                      <small>NENHUM ARTIGO</small>
                      <p>Não há artigos em destaque no momento</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="orion__store-section" id="orion__store-section">
          <img
            className="orion__store-image"
            src={orionStore}
            alt="Loja Orion sinais"
          />
          <div className="orion__store-content">
            <div className="orion__store-header">
              <h2 className="orion__landing-title">LOJA ORION SINAIS</h2>
              <h3>Camisetas Exclusivas Orion Sinais</h3>
              <p>
                Além dos sinais estratégicos, oferecemos camisetas exclusivas
                para você mostrar seu estilo no mundo das criptomoedas.
              </p>
            </div>
            <a
              href={STORE_URL}
              className="orion__default-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Comprar Agora
            </a>
          </div>
        </div>

        <div className="orion__faq-section" id="orion__faq-section">
          <div className="orion__faq-header">
            <h2 className="orion__landing-title">DÚVIDAS</h2>
            <h3>Confira as principais dúvidas a respeito dos sinais</h3>
            <p>
              Não conseguiu sanar todas as suas dúvidas? Estamos aqui pra
              ajudar! Envie suas dúvidas e sugestões e nos ajude a construir a
              melhor plataforma para você!
            </p>
            <a
              style={{ textDecoration: "underline" }}
              href="#orion__contact-section"
            >
              Dúvidas? Converse conosco
            </a>
          </div>
          <div className="orion__faq-content">
            <FaqSection />
          </div>
        </div>
        <div className="orion__about-section" id="orion__about-section">
          <img
            alt="Foto da escultura globo da Babson College"
            src={babson}
            className="orion__about-image"
          />
          <div className="orion__about-content">
            <img alt="Logo da Orion Sinais" src={logo}></img>
            <div className="orion__about-content-text">
              <p>
                Imersos no empreendedorismo, na Babson College em Boston/MA -
                EUA, embarcamos em uma jornada para criar a Orion Sinais unidos
                por uma paixão compartilhada por tecnologia, blockchain e
                criptomoedas.
              </p>
              <p>
                Nossos especialistas desenvolveram um algoritmo automatizado que
                enviam sinais para a plataforma e para o Telegram.{" "}
              </p>
            </div>
            <button
              className="orion__default-button"
              onClick={() => navigate("/sobre-nos")}
            >
              Saiba mais
            </button>
          </div>
        </div>
        <div className="orion__contact-section" id="orion__contact-section">
          <div className="orion__contact-section-header">
            <small>ENTRE EM CONTATO</small>
            <h1>Nossos especialistas estão prontos para atender você!</h1>
          </div>
          <div className="orion__contact-section-content">
            <div className="orion__lp-contact-info">
              <p>
                Criamos esse canal de comunicação para que você possa esclarecer
                todas as suas dúvidas:
              </p>
              <div className="orion__contact-info-content">
                <EnvelopeIcon className="orion__contact-icon" />
                <p>
                  <b>contato@orionsinais.com.br</b>
                </p>
              </div>
              <hr />
              <div className="orion__contact-info-content">
                <MapPinIcon className="orion__contact-icon" />
                <div className="orion__contact-info-address">
                  <p>
                    <b>Av. Paulista, 1636 - Conjunto 4</b>
                  </p>
                  <p>Pav. 1504 - São Paulo/SP</p>
                </div>
              </div>
            </div>
            <div className="orion__contact-form">
              <p>
                Preencha o formulário para mais informações, dúvidas ou
                sugestões
              </p>
              <iframe
                title="contact-form-iframe"
                aria-label="Entre em contato"
                frameBorder="0"
                width="100%"
                height="500"
                src="https://forms.zohopublic.com/orionsinais/form/Entreemcontato1/formperma/ycV-qozeIk6iWWK0CAhMJJbdfG3JyVviuyNcQ_KzySE"
              ></iframe>
            </div>
          </div>
        </div>
        <Footer />

        {isModalOpen && (
          <div
            className="orion__screenshot-modal"
            onClick={() => setIsModalOpen(false)}
          >
            <div className="orion__screenshot-modal-content">
              <img
                src={dashboardScreenshots}
                alt="Capturas de tela do dashboard"
                className="orion__screenshot-modal-image"
              />
              <button
                className="orion__screenshot-modal-close"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LandingPage;
